import { render, staticRenderFns } from "./ListPropertiesOwners.vue?vue&type=template&id=c6f73e0e&"
import script from "./ListPropertiesOwners.vue?vue&type=script&lang=js&"
export * from "./ListPropertiesOwners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports